class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    })
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach(animation => animation.play());
    } else {
      this.animations.forEach(animation => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.summary = this.mainDetailsToggle.querySelector('summary');
    this.onOutsidePointer = (event) => {
      if (this.mainDetailsToggle.open && !this.contains(event.target)) this.close();
    };
    this.summary.addEventListener('click', (event) => {
      if (!this.useSmoothMenu()) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      if (this.closingAnimation) {
        this.cancelClosing(true);
      } else if (this.mainDetailsToggle.open) {
        this.close();
      } else {
        this.mainDetailsToggle.open = true;
        this.summary.setAttribute('aria-expanded', 'true');
      }
    }, true);
    this.addEventListener('keyup', (event) => {
      if (event.key !== 'Escape' || !this.useSmoothMenu() || !this.mainDetailsToggle.open) return;
      event.stopImmediatePropagation();
      this.summary.focus();
      this.close();
    }, true);
  }

  connectedCallback() {
    document.addEventListener('pointerdown', this.onOutsidePointer);
  }

  disconnectedCallback() {
    document.removeEventListener('pointerdown', this.onOutsidePointer);
    this.cancelClosing();
  }

  useSmoothMenu() {
    return this.content.classList.contains('header__submenu') &&
      window.matchMedia('(min-width:990px) and (prefers-reduced-motion:no-preference)').matches;
  }

  cancelClosing(reopen = false) {
    if (!this.closingAnimation) return;
    const current = getComputedStyle(this.content);
    const start = { opacity: current.opacity, transform: current.transform };
    this.closingAnimation.onfinish = null;
    this.closingAnimation.cancel();
    this.closingAnimation = null;
    this.content.style.removeProperty('animation');
    this.content.style.removeProperty('pointer-events');
    this.content.style.removeProperty('opacity');
    this.content.style.removeProperty('transform');
    this.summary.setAttribute('aria-expanded', String(this.mainDetailsToggle.open));
    if (reopen) {
      this.content.style.animation = 'none';
      this.content.style.opacity = '1';
      this.content.style.transform = 'translateY(0)';
      this.openingAnimation = this.content.animate([start, { opacity: '1', transform: 'translateY(0)' }], { duration: 180, easing: 'cubic-bezier(.22,1,.36,1)' });
    }
  }

  close() {
    if (!this.mainDetailsToggle.open || this.closingAnimation) return;
    if (!this.useSmoothMenu()) {
      super.close();
      return;
    }
    const current = getComputedStyle(this.content);
    const start = { opacity: current.opacity, transform: current.transform };
    this.openingAnimation?.cancel();
    this.openingAnimation = null;
    this.content.style.animation = 'none';
    this.content.style.pointerEvents = 'none';
    this.summary.setAttribute('aria-expanded', 'false');
    this.closingAnimation = this.content.animate(
      [start, { opacity: '0', transform: 'translateY(-5px)' }],
      { duration: 180, easing: 'cubic-bezier(.4,0,1,1)', fill: 'forwards' }
    );
    this.closingAnimation.onfinish = () => {
      super.close();
      this.cancelClosing();
    };
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty('--header-bottom-position-desktop', `${Math.floor(this.header.getBoundingClientRect().bottom)}px`);
  }
}

customElements.define('header-menu', HeaderMenu);
